var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector76(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 330,
    viewBox: "0 0 66 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-241.99 328.283C-223.075 304.894 -218.956 301.188 -199.547 286.372C-194.793 282.741 -185.549 277.03 -174.131 271.575C-170.714 269.94 -167.326 268.457 -163.985 267.098C-140.078 257.405 -113.295 256.036 -86.8442 258.288C-19.3551 264.038 41.5568 227.506 59.3141 172.195C77.0999 116.789 47.8398 55.2629 2.17951 25.241C-3.76173 21.335 -31.7976 4.10496 -62.5572 1.55799C-159.677 -6.51058 -198.485 87.5656 -227.868 230.709C-228.437 233.494 -230.611 246.751 -231 249.564L-242 328.292L-241.99 328.283Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector76);
export default __webpack_public_path__ + "static/media/vector7-6.926071657dde545b10fda2f086265df6.svg";
export { ForwardRef as ReactComponent };